import { api } from "@/api";
import { QueryConfig } from "@/shared/types/base";
import { Venta } from "@/shared/types/venta";
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils";
import { useQuery } from "@tanstack/react-query";

export interface VentaReporteQuery {
    desde?: string,
    hasta?: string,
    clienteId?: string,
    vendedorId?: string,
    credito?: string,
}

export interface VentaReporteResponse {
    count: number,
    total: number,
    utilidad: number,
    result: Venta[]
}

export async function getVentaReporte(query: VentaReporteQuery = {}): Promise<VentaReporteResponse> {
    await sleep(1000);
    const response = await api.get("reportes/venta", { params: removeNullOrEmptyKeys(query) })
    return response.data;
}

export function useGetVentaReporteQuery(query: VentaReporteQuery = {}, queryConfig: QueryConfig<VentaReporteResponse> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: () => getVentaReporte(query),
        queryKey: ["reportes", "venta", query]
    })
}